import {HallBaseConfig} from "../../configurations/reducers/configurationsList.reducer";
import {Action} from "../../../actions/actions";
import {HallsActionTypes} from "../actions/actionTypes";
import {OperationStep} from "../types/license-history";
import _ from "lodash";

export interface License {
    automated: boolean;
    duration: number;
    warning_period: number;
    generation: string | null;
    expiration: string | null;
    hall_id: number;
}

export function inspectingHall(
    state: HallBaseConfig = null,
    action: Action
): HallBaseConfig {
    switch (action.type) {
        case HallsActionTypes.GET_HALL:
            return null;

        case HallsActionTypes.GET_HALL_SUCCESS:
            return action.payload.hall;
        default:
            return state;
    }
}

export function inspectingHallLoading(
    state: boolean = true,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_HALL:
            return true;

        case HallsActionTypes.GET_HALL_SUCCESS:
        case HallsActionTypes.GET_HALL_FAIL:
            return false;
        default:
            return state;
    }
}

export interface ConfigVersion {
    hall: number;
    server_id: number;
    id: number;
    version: number;
    created_on: string;
    auto_session_enabled: string;
}
export interface LicenseServerData {
    license: any ;
    machines: any;
    multiprogressives: any;
    progressives: any;
}

export interface HallServer {
    id: number;
    name: string;
    created_on: string;
    code: string;
    hall_id: number;
    type: number;
    license?: any;
    cashing?: object;
    active: boolean;
    system_server_version?: string;
    version?: number | null;
    latest_config_id?: number | null;
    latest_spec_version?: number | null;
    debug_mode: boolean;
    perpetual_license: boolean;
    is_egames?: boolean;
    is_online: boolean;
    last_online?: any;
    current_data?: LicenseServerData | null;
    config: ConfigVersion
}

export function inspectingHallServers(
    state: HallServer[] = [],
    action: Action
): HallServer[] {
    let newState: HallServer[];
    switch (action.type) {
        case HallsActionTypes.TOGGLE_SERVER_ACTIVE_SUCCESS:
            newState = _.cloneDeep(state);
            const index = _.findIndex(newState, [
                "id",
                action.payload.serverId
            ]);
            if (index > -1) {
                newState[index].active = !newState[index].active;
            }
            return newState;
        case HallsActionTypes.TOGGLE_SERVER_DEBUG_MODE_SUCCESS:
            newState = _.cloneDeep(state);
            const index_server = _.findIndex(newState, [
                "id",
                action.payload.serverId
            ]);
            if (index_server > -1) {
                newState[index_server].debug_mode = !newState[index_server].debug_mode;
            }
            return newState;
        case HallsActionTypes.TOGGLE_SERVER_PERPETUAL_LICENSE_SUCCESS:
            newState = _.cloneDeep(state);
            const index_server_license = _.findIndex(newState, [
                "id",
                action.payload.serverId
            ]);
            if (index_server_license > -1) {
                newState[index_server_license].perpetual_license = !newState[index_server_license].perpetual_license;
            }
            return newState;
        case HallsActionTypes.GET_SERVERS:
            return [];
        case HallsActionTypes.GET_SERVERS_SUCCESS:
            return action.payload.servers;
        default:
            return state;
    }
}

export function inspectingHallServersLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_SERVERS:
            return true;

        case HallsActionTypes.GET_SERVERS_SUCCESS:
        case HallsActionTypes.GET_SERVERS_FAIL:
            return false;
        default:
            return state;
    }
}

export function inspectingServer(
    state: HallServer = null,
    action: Action
): HallServer {
    switch (action.type) {
        case HallsActionTypes.CLEAN_SERVER:
            return null;
        case HallsActionTypes.GET_SERVER_SUCCESS:
            return action.payload;
        case HallsActionTypes.GET_SERVER_FAIL:
            return null;
        default:
            return state;
    }
}

export function inspectingServerLoading(
    state: boolean = true,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_SERVER:
            return true;

        case HallsActionTypes.GET_SERVER_SUCCESS:
        case HallsActionTypes.GET_SERVER_FAIL:
            return false;
        default:
            return state;
    }
}

export interface LicenseHistoryState {
    count: number;
    results: { [key: string]: OperationStep[] };
}

export function inspectingServerConfigurationsList(
    state: ConfigVersion[] = [],
    action: Action
): ConfigVersion[] {
    switch (action.type) {
        case HallsActionTypes.GET_CONFIGURATIONS_LIST:
            return [];
        case HallsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS:
            return action.payload.configs;
        default:
            return state;
    }
}

export function inspectingServerConfigurationsListLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_CONFIGURATIONS_LIST:
            return true;
        case HallsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS:
        case HallsActionTypes.GET_CONFIGURATIONS_LIST_FAIL:
            return false;
        default:
            return state;
    }
}

export interface ServerLicenseHistoryState {
    results: [];
    loading: boolean;
}

const initialState: ServerLicenseHistoryState = {
    results: [],
    loading: false
};

export function serversInfo(state: any = null, action: Action): any {
    switch (action.type) {
        case HallsActionTypes.GET_SERVERS_INFO_SUCCESS:
            return action.payload.serversInfo;

        default:
            return state;
    }
}

export function serversInfoLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_SERVERS_INFO:
            return true;
        case HallsActionTypes.GET_SERVERS_INFO_SUCCESS:
        case HallsActionTypes.GET_SERVERS_INFO_FAIL:
            return false;
        default:
            return state;
    }
}

export function submittingServerLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.CREATE_SERVER:
        case HallsActionTypes.CLONE_SERVER:
        case HallsActionTypes.UPDATE_SERVER:
            return true;
        case HallsActionTypes.UPDATE_SERVER_SUCCESS:
        case HallsActionTypes.UPDATE_SERVER_FAIL:
        case HallsActionTypes.CREATE_SERVER_SUCCESS:
        case HallsActionTypes.CREATE_SERVER_FAIL:
            return false;
        case HallsActionTypes.CLONE_SERVER_SUCCESS:
        case HallsActionTypes.CLONE_SERVER_FAIL:
            return false;
        default:
            return state;
    }
}

export function productionServer(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_PRODUCTION_INFO_SUCCESS:
            return action.payload['production_sys'];
        case HallsActionTypes.GET_PRODUCTION_INFO_FAIL:
            return false;
        default:
            return state;
    }
}
